/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { Reducer } from 'redux';
import { APIActions } from '../actions/apiActions';
import { IState } from '../store/types/StateTypes';
import { MetadataActions } from '../actions/metadataActions';
import { VisualizationActions } from '../actions/visualizationActions';
import { VisualizationChooserActions } from '../actions/visualizationChooserActions';
import { IReducerAction, IVisualizationReducerActionData } from '../store/types/ReducerTypes';
import { MultiAxisDataActions } from '../actions/multiAxisDataActions';

const genericVisualizationReducer: Reducer<any, IReducerAction<IVisualizationReducerActionData>> = (state: IState, action: IReducerAction<IVisualizationReducerActionData>) => {
    let newState = state;

    // on any action, which potentially may affect the visualization static props
    if (action.type === APIActions.API_PROPERTIES_UPDATE
        || action.type === APIActions.API_RESIZE
        || action.type === MultiAxisDataActions.MULTI_AXIS_DRILLDOWN_TO
        || action.type === VisualizationChooserActions.VISUALIZATION_CHOOSER_SELECTED_TYPE
        || action.type === MetadataActions.METADATA_LOADED) {

        const visualizationProps = newState.visualization[newState.visualizationDescriptor.name];
        const { staticPropertiesReducer } = newState.visualizationDescriptor;

        newState = {
            ...newState,
            visualization: {
                ...newState.visualization,
                [newState.visualizationDescriptor.name]: {
                    ...visualizationProps,
                    staticProperties:
                        staticPropertiesReducer(visualizationProps.staticProperties, newState, action)
                }
            }
        };
    }

    if ((action.type === VisualizationActions.VISUALIZATION_UPDATE_DYNAMIC_PROPERTIES)
        || (action.type === MultiAxisDataActions.MULTI_AXIS_SET_LEVEL_EXPANDED_STATE && action.data && action.data.dynamicProperties)
        || (action.type === MultiAxisDataActions.MULTI_AXIS_SET_MEMBER_EXPANDED_STATE && action.data && action.data.dynamicProperties)
    ) {
        const visualizationProps = state.visualization[state.visualizationDescriptor.name];

        const { data } = action;
        const dynamicPropertiesFromAction = data && data.dynamicProperties;

        newState = {
            ...state,
            visualization: {
                ...state.visualization,
                [state.visualizationDescriptor.name]: {
                    ...visualizationProps,
                    dynamicProperties: {
                        ...visualizationProps.dynamicProperties,
                        ...dynamicPropertiesFromAction
                    }

                }
            }
        };
    }

    return newState;
};

export default genericVisualizationReducer;
